export enum AdActions {
  AD_START = 'ad-start',
  AD_STOP = 'ad-stop',
  AD_BLOCKER_DETECTED = 'ad-blocker-detected',
  AD_ERRORED = 'ad-errored',
}

export enum TealiumEventNames {
  PLAYER_START = 'player_start',
  PLAYER_PLAY = 'player_play',
  PLAYER_SKIP = 'player_skip',
  PLAYER_MENU_PLAY = 'player_menu_play',
  PLAYER_RESUME = 'player_resume',
  PLAYER_STOP = 'player_stop',
  PLAYER_SWITCH = 'player_switch',
  PLAYER_PAUSE = 'player_pause',
  PLAYER_VOLUME = 'player_volume',
  PLAYER_COMPLETE = 'player_complete',
  PLAYER_HEARTBEAT = 'player_heartbeat',
  PLAYER_ERROR = 'player_error',
  PLAYER_RECONNECT = 'player_reconnect',
  PLAYER_LOAD_MEDIA = 'player_load_media',
  PLAYER_CLICK = 'player_click',
  OUTBOUND_CLICK = 'outbound_click',
}

export enum TealiumEventCategory {
  PLAYER = 'player',
}

export enum HeartbeatEvents {
  START_HEARTBEAT = 'START_HEARTBEAT',
  STOP_HEARTBEAT = 'STOP_HEARTBEAT',
  RESET_HEARTBEAT = 'RESET_HEARTBEAT',
  UPDATE_TIME = 'UPDATE_TIME',
}

// The Heartbeat intervals expressed in milliseconds.
export enum HeartbeatIntervals {
  ONE_MINUTE = 1 * 60 * 1000,
  SEVEN_MINUTES = 7 * 60 * 1000,
  FIFTEEN_MINUTES = 15 * 60 * 1000,
  FORTYFIVE_MINUTES = 45 * 60 * 1000,
}

export enum HeartbeatLabels {
  LABEL_1 = 1,
  LABEL_8 = 8,
  LABEL_15 = 15,
}
